import type { Category } from "@/shared/domains";
import { parseResponseData, publicAPI } from "@/shared/lib";
import type { ImperialBmiInputs } from "@/shared/models";
import { categoryEligibilitySchema } from "../models";

type SubmitBMIWithCategoriesParams = ImperialBmiInputs & {
  selectedCategories: Category["slug"][];
};

export const submitBMIWithCategories = async ({
  weightInPounds,
  ...params
}: SubmitBMIWithCategoriesParams) => {
  const response = await publicAPI.post(
    "/onboarding/product-category/eligibility",
    {
      weight: weightInPounds,
      ...params,
    },
  );

  return parseResponseData(response, categoryEligibilitySchema.array());
};
